var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-template',{attrs:{"rgb":"255,255,255","use-bstyle":""}},[_c('div',{staticClass:"gcash-box"},[_c('img',{attrs:{"src":require("@/assets/images/stayPay/paymethod/union-bank-icon.png"),"alt":""}}),_c('p',{staticClass:"pay-title"},[_vm._v("UnionBank "+_vm._s(_vm.$t('userCenter.paymentMethod')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }